<template>
  <div class="suScreen screen white-bg p20 pb0 flex f13 cl333 borderRadius">
    <div style="min-width: 40px">分类：</div>
    <div class="sort1">
      <el-select v-model="tab" placeholder="请选择" style="width: 100%;" @change="tabClick">
        <el-option
            v-for="(item,index) in tabList"
            :key="index + 1"
            :label="item.category_name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="flex fl-war sort">
      <div
          class="ml30 mb20 pointer discolour-blue1"
          :class="{cl0066FF: tab === item.id}"
          v-for="(item,index) in tabList"
          @click="tabClick(item)"
          :key="index">
        {{ item.category_name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "su-screen",
  props: {
    tabList: {
      type: Array,
      default() {
        return []
      }
    },
    tab: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {

    };
  },
  methods: {
    tabClick(item) {
      this.$emit('tabClick', item)
    }
  }
}
</script>
<style scoped lang="scss">
.suScreen {
  .sort1 {
    //隐藏
    display: none;
  }
}

@media screen and (max-width: 750px) {
  .suScreen {
    //垂直居中
    align-items: center;
  }

  .sort1 {
    //显示
    display: block;
    width: 100%;
  }

  .sort {
    //隐藏
    display: none;
  }
}
</style>
